'use strict';

require('./email-styles.scss');
var React = require('react');
var request = require('superagent');
var EmailLinkElement = require('./email-link-element.jsx');

var EmailBody = React.createClass({

  getInitialState: function() {
    return {
      pagesData: null,
      paginationCount: 1,
      lastPage: false,
      error: null
    }
  },

  componentDidMount: function() {
    this.handlePagination();
  },

  handlePagination: function() {
    const self = this;
    const paginationCount = this.state.paginationCount;

    request
      .get('/api/newsletters/headers' + '?page=' + paginationCount)
      .end(function(err, res){
        if (err) {
          alert(err);
        } else {
          if (typeof res.body == 'undefined'){
            self.setState({error:'Not Found Email-Pagination Data'});
          }
          if (res.body.length < 10) {
            self.setState({
              pagesData: res.body,
              lastPage: true
            });
          } else {
            self.setState({
              pagesData: res.body,
              lastPage: false
            });
          }
        }
      });
  },

  prevPagination: function() {
    if (this.state.paginationCount == 1) return;
    this.setState({
      paginationCount: this.state.paginationCount - 1
    }, () => {
      this.handlePagination();
    });
  },

  nextPagination: function() {
    if (this.state.lastPage) return;
    this.setState({
      paginationCount: this.state.paginationCount + 1
    }, () => {
      this.handlePagination();
    });
  },

  renderLinks: function(pagesData) {
    return pagesData.map((item, index) => 
      <EmailLinkElement 
        key={item.subject + index}
        _id={item.campaignId}
        transformDate={item.send_time}
        subject={item.subject} />
    )},

  render: function() {
    const pagesData = this.state.pagesData || [];

    const regex = new RegExp(/stoop/i)
    const stoopCampaigns = Object.values(pagesData).filter(item => regex.test(item.title))
    
    const linkElements = this.renderLinks(stoopCampaigns);

    return (
      <div className="body-container">
        <h1 className="title">Previous Issues:</h1>

        <div className="issues-content">

          <div className="issues-list" id="list">
            {linkElements}
          </div>

          <div className="issues-pagination clear-fix">

            <div className="issues-pagination__previous">
              <button id="previous"
                      onClick={this.prevPagination} >Previous Page</button>
            </div>

            <div className="issues-pagination__current">
              Page <span id="pageNumberContainer">{this.state.paginationCount}</span>
            </div>

            <div className="issues-pagination__next">
              <button id="next"
                      onClick={this.nextPagination} >Next Page</button>
            </div>

          </div>

          <div className="footer-links">
            <a href="/terms-conditions/">Terms & Conditions</a>
            <a href="/privacy-policy/">Privacy Policy</a>
          </div>

        </div>

      </div>
    );
  }
});

module.exports = EmailBody;


// WEBPACK FOOTER //
// ./src/client/components/email/email-body.jsx